<template>
<div id="ProfitLossReport">

   <!-- <v-row class="mb-2 ml-0">
        <v-icon @click="$router.go(-1)" class="mr-2">mdi-arrow-left</v-icon>
        Reports <v-icon size="16" class="ml-2">mdi-greater-than</v-icon> <span class="font-weight-bold ml-2">{{$route.name}}</span>
    </v-row> -->
    <!-- <v-btn depressed style="float: right;margin:-36px 0 0 0" class="primary" @click="">Export</v-btn> -->
    <v-row>
        <v-col cols="auto">
           <!-- <label class="text-uppercase grey--text font-weight-bold" style="display: block; padding-left: 5px">Date</label> -->
            <datePicker :initial="initialDate" @date="date=$event" @isLastNDays="isLastNDays=$event"
                        :appendToBody="true" opens="right" />
        </v-col>
        <v-col cols="3">
           <!-- <label class="text-uppercase grey--text font-weight-bold" style="display: block; padding-left: 5px">Branch</label> -->
                <v-select outlined dense class="branch-field" :items="Warehouses"
                      v-model="selectedWarehouse" item-text="name" item-value="id" placeholder="Select Branch"/>
        </v-col>
        <v-col cols="auto"> <!-- mt-7 -->
            <v-btn depressed class="primary mr-4" @click="getReportData()" :disabled="disableApplyBtn">Apply</v-btn>
            <v-btn outlined @click="onClearFilter">Clear</v-btn>
        </v-col>
    </v-row>

    <v-data-table :headers="headers" :items="products" :loading="$apollo.queries.products.loading" @update:page="$vuetify.goTo(0)">
        <template v-slot:no-data>No Products Available</template>
        <template v-slot:no-results>No Products Available</template>
        <template v-slot:item.name="{ item }">
            <v-avatar tile class="my-3 avatar mr-6" style="border: 1px solid grey; border-radius: 5px !important;" size="60" @click.stop="openGallery(item.Attachments)" title="View Image">
                <v-img v-if="item.Attachments.length" :src="imgWpx(item.Attachments[0].path, 200)" alt="image">
                    <template v-slot:placeholder>
                        <v-icon size="50" color="blue-grey lighten-5">mdi-image</v-icon>
                        <v-progress-circular width="3" size="24" indeterminate style="position: unset" color="deep-orange lighten-2"></v-progress-circular>
                    </template>
                </v-img>
            </v-avatar>
            <span class="ellipsis product-name">
                                <span :title="item.name">{{ item.name || '-'}}</span><br>
                                <span :title="item.sku" class="f-12 grey--text text--darken-1">{{item.sku || '-'}}</span>
                            </span>
        </template>
        <template v-slot:item.aggregate.avg.avgSalePrice="{ item }">{{item.aggregate.avg.avgSalePrice | currencyFilter}}</template>
        <template v-slot:item.aggregate.avg.avgPurchasePrice="{ item }">{{item.aggregate.avg.avgPurchasePrice | currencyFilter}}</template>
        <template v-slot:item.aggregate.sum.totalSaleAmount="{ item }">{{item.aggregate.sum.totalSaleAmount | currencyFilter}}</template>
        <template v-slot:item.aggregate.sum.totalPurchaseAmount="{ item }">{{item.aggregate.sum.totalPurchaseAmount | currencyFilter}}</template>
        <template v-slot:item.aggregate.profitAmount="{ item }">{{item.aggregate.profitAmount | currencyFilter}}</template>
        <template v-slot:item.aggregate.profitPercent="{ item }">{{roundOffValue(item.aggregate.profitPercent*100)}} %</template>
        <template slot="body.append" v-if="products.length">
            <tr style="color: teal; font-weight: bolder">
                <td>Summary</td>
                <td class="text-end">-</td><td class="text-end">-</td><td class="text-end">-</td>
                <td class="text-end">{{summary.sumSaleAmount | currencyFilter}}</td>
                <td class="text-end">{{summary.sumPurchaseAmount | currencyFilter}}</td>
                <td class="text-end">{{(summary.sumSaleAmount - summary.sumPurchaseAmount) | currencyFilter}}</td>
                <td class="text-end">{{profitPercentage(summary.sumPurchaseAmount, summary.sumSaleAmount)}} %</td>
            </tr>
        </template>
    </v-data-table>

    <Snackbar :toaster="toaster"/>
    <gallery id="gallery-profit-loss-report" :images="galleryImages" :index="galleryIndex" @close="galleryIndex=null"/>
</div>
</template>

<script>
import Constants from "../../Constants/Constants";
import moment from 'moment';
import DatePicker from "../../components/Common/datePicker";
import gallery from '../../mixins/gallery';
import Snackbar from "../../components/Common/Snackbar";
import {GET_PROFIT_LOSS_PRODUCTS} from "../../graphql/queries/Products";
import {profit_loss_products_aggregate, profit_loss_products_statement} from "../../graphql/customStatement";
import {roundOffValue, profitPercentage} from "../../util/helpers";
import {GET_ALL_WAREHOUSES} from "../../graphql/queries/Warehouses";
let summary = { sumSaleAmount:0, sumPurchaseAmount:0 };
export default {
    name: "ProfitLossReport",
    components: {Snackbar, DatePicker},
   /* props: ['warehousesArr'], */
    mixins: [gallery],
    apollo:{
        Warehouses: { query: GET_ALL_WAREHOUSES },
        products: {
            query: GET_PROFIT_LOSS_PRODUCTS,
            fetchPolicy: 'network-only',
            skip(){ return this.skipProducts },
            variables() {
                return {
                    statement: profit_loss_products_statement(moment(this.date.startDate).format(this.isLastNDays?'YYYY-MM-DDTHH:mm:ss+05:30':'YYYY-MM-DDT00:00:00+05:30'),
                                                              moment(this.date.endDate).format('YYYY-MM-DDT23:59:59+05:30'), this.selectedWarehouse),
                    aggregate: profit_loss_products_aggregate
                }
            },
            result({data}) { this.products = data.products; this.skipProducts = true; this.prepareSummaryRow(data.products) },
        },
    },
    data(){
        return{
            Constants: Constants,
            moment: moment,
            date: {startDate: moment(), endDate: moment()},
            initialDate: {startDate: moment().toDate(), endDate: moment().toDate()},
            isLastNDays: false,
            selectedWarehouse: '', Warehouses: [],
            headers: [
                { text: 'PRODUCT', value: 'name', width:370}, { text: 'AVG SALE PRICE', value: 'aggregate.avg.avgSalePrice', align:'end' },
                { text: 'AVG PURCHASE PRICE', value: 'aggregate.avg.avgPurchasePrice', align:'end' }, { text: 'QTY', value: 'aggregate.sum.totalQty', align:'end' },
                { text: 'TOTAL SALE AMT', value: 'aggregate.sum.totalSaleAmount', align:'end' }, { text: 'TOTAL PURCHASE AMT', value: 'aggregate.sum.totalPurchaseAmount', align:'end' },
                { text: 'PROFIT AMT', value: 'aggregate.profitAmount', align:'end' }, { text: 'PROFIT %', value: 'aggregate.profitPercent', align:'end' }
            ],
            products: [],
            skipProducts: true,
            summary: {...summary},
            toaster: {enable: false},
            roundOffValue, profitPercentage
        }
    },
    computed:{
        disableApplyBtn(){
            return (this.selectedWarehouse === '');
        }
    },
    methods:{
        prepareSummaryRow(products){
            this.summary = {...summary}
            products.forEach(p => {
                this.summary.sumSaleAmount = this.summary.sumSaleAmount + p.aggregate.sum.totalSaleAmount;
                this.summary.sumPurchaseAmount = this.summary.sumPurchaseAmount + p.aggregate.sum.totalPurchaseAmount;
            } )
        },
        getReportData(){
            this.skipProducts = false
        },
        onClearFilter(){                                              /* Reset Filters */
            this.initialDate = {startDate: moment().toDate(), endDate: moment().toDate()};
            this.isLastNDays = false;
            this.selectedWarehouse = '';
            this.products = [];
        }
    }
}
</script>

<style scoped>
#ProfitLossReport{
    padding: 0 20px 20px 20px;
}
/deep/ .reportrange-text {
    width: 260px;
}
.avatar{
    cursor: pointer;
}
.ellipsis{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: default;
}
.product-name {
    display: inline-block;
    vertical-align: middle;
    width: 250px;
    max-width: 250px;
}
.f-12{
    font-size: 12px;
}
</style>